<template>
	<view class="box">
		<!-- 进度条 -->
		<div class="ss">
			<view style="padding: 15rpx 0%;">
					<uni-steps :options="list" :active="active" active-color="#fd8b4d" />
			</view>
		</div>

		<!-- 选择日期 -->
		<div class="box2">
			<div class="date_top">
				<div class="date_style">
					<div>
						<span class="date_txt1">西安市</span>
						<uni-icons type="bottom"></uni-icons>
					</div>
					<div>
						<span class="date_txt2">共32项检查项目</span>
						<uni-icons type="right" size="14"></uni-icons>
					</div>
				</div>
				<div class="date_bottom">
					<view class="example-body">
						<uni-datetime-picker type="date" :clear-icon="true" v-model="single" @maskClick="maskClick" />
					</view>
				</div>
			</div>
			
			<!--底部 -->
			<div class="bottom">
				<div class="bottom_style">
					<div class="bottom_txt_sty">
						<span class="bottom_txt1">爱康国宾西安曲江分院</span>
						<div class="bottom_txt4">国宾</div>
					</div>
					<span class="bottom_txt2">西安市雁塔区慈恩西路南段曲江六号东门1-3层</span>
				</div>
				<div>
					<span class="bottom_txt3">8.45km</span>
				</div>
			</div>
			
			<div class="bottom_style1">
				<span class="bottom_txt5">￥1219.00</span>
				<span class="bottom_txt6">已约99%</span>
				<button type="primary" size="mini"
					style="margin: 30px 10px; width: 100px; background-color: #fff; color: #fd8b4d; border-radius: 20px 20px 20px 20px; border: 1px solid #fd8b4d;"
					@click="changeOne">下一步</button>
			</div>
		</div>
		

	</view>
</template>

<script>
	export default {
		data() {
			return {
				active: 0,
				list: [{
					title: '选择分院'
				}, {
					title: '选择加项'
				}, {
					title: '确认信息'
				}],

				single: '',
				datetimesingle: '',
				range: ['2021-02-1', '2021-3-28'],
				datetimerange: [],
				start: Date.now() - 1000000000,
				end: Date.now() + 1000000000
			}
		},
		watch: {
			datetimesingle(newval) {
				console.log('单选:', this.datetimesingle);
			},
			range(newval) {
				console.log('范围选:', this.range);
			},
			datetimerange(newval) {
				console.log('范围选:', this.datetimerange);
			}
		},
		mounted() {
			setTimeout(() => {
				this.datetimesingle = Date.now() - 2 * 24 * 3600 * 1000
				this.single = '2021-2-12'
				this.datetimerange = ["2021-07-08 0:01:10", "2021-08-08 23:59:59"]
			}, 3000)
		},
		methods: {
			changeOne() {
				uni.navigateTo({
					url: '/pages/hot/hot'
				})
			},

			change(e) {
				this.single = e
				console.log('change事件:', this.single = e);
			},
			changeLog(e) {
				console.log('change事件:', e);
			},
			maskClick(e) {
				console.log('maskClick事件:', e);
			},
		}
	}
</script>

<style lang="scss">
	.box{
		height: 1380rpx;
		background-color: #f2f4f3;
		display: flex;
		align-items: center;
		flex-direction: column;
	}
	.ss {
		height: 100rpx;
		width: 100%;
		margin-bottom: 20rpx;
		background-color: #fff;
	}
	.box2{
		width: 720rpx;
		height: 550rpx;
		background-color: #fff;
		border-radius: 15rpx;
	}

	.date_style {
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
	}

	.date_txt1 {
		font-size: 16px;
	}

	.date_txt2 {
		font-size: 14px;
	}
	.bottom{
		width: 100%;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
	}
	.bottom_style{
		margin-left: 20rpx;
		display: flex;
		flex-direction: column;
	}
	.bottom_txt_sty{
		display: flex;
		justify-content: space-between;
	}
	.bottom_txt1{
		font-weight: 600;
		margin-bottom: 5px;
	}
	.bottom_txt4{
		width: 25px;
		height: 15px;
		font-size: 12px;
		margin-right: 10px;
		border-radius: 2px 2px 2px 2px;
		color: #ff4f00;
		background-color: #f4cfb8;
		
	}
	.bottom_txt2{
		 font-size: 12px;
		 color: #838383;
	}
	.bottom_txt3{
		margin-right: 10rpx;
		 font-size: 14px;
		 color: #838383;
	}
	.bottom_style1{
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	.bottom_txt5{
		font-size: 22px;
		font-weight: 800;
		color: #fd8b4d;
	}
	.bottom_txt6{
		margin-right: 160rpx;
		font-size: 10px;
		color: #838383;
	}
</style>
